import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

export default function Database() {
  const [employees, setEmployees] = useState([]);
  const [filter, setFilter]       = useState({ search: '', status: 'all' });
  const [loading, setLoading]     = useState(false);

  useEffect(() => { loadAll(); }, []);

  async function loadAll() {
    setLoading(true);
    const data = await fetch(`${API}/employees/all`).then(r => r.json());
    setEmployees(Array.isArray(data) ? data : []);
    setLoading(false);
  }

  async function fireEmployee(id) {
    if (!window.confirm('Уволить сотрудника?')) return;
    await fetch(`${API}/employees/${id}/fire`, { method: 'POST' });
    loadAll();
  }

  async function restoreEmployee(id) {
    if (!window.confirm('Восстановить сотрудника?')) return;
    await fetch(`${API}/employees/${id}/restore`, { method: 'POST' });
    loadAll();
  }

  const filtered = employees.filter(e => {
    const matchSearch = !filter.search ||
      e.full_name.toLowerCase().includes(filter.search.toLowerCase()) ||
      (e.phone && e.phone.includes(filter.search)) ||
      (e.inn && e.inn.includes(filter.search));
    const matchStatus = filter.status === 'all' ||
      (filter.status === 'active' && e.is_active) ||
      (filter.status === 'fired' && !e.is_active);
    return matchSearch && matchStatus;
  });

  const activeCount = employees.filter(e => e.is_active).length;
  const firedCount  = employees.filter(e => !e.is_active).length;

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>База сотрудников</h2>
      </div>

      <div className="stat-cards" style={{ marginBottom:16 }}>
        <div className="stat-card">
          <div className="label">Всего</div>
          <div className="value" style={{ fontSize:22 }}>{employees.length}</div>
        </div>
        <div className="stat-card">
          <div className="label">Активных</div>
          <div className="value green" style={{ fontSize:22 }}>{activeCount}</div>
        </div>
        <div className="stat-card">
          <div className="label">Уволенных</div>
          <div className="value red" style={{ fontSize:22 }}>{firedCount}</div>
        </div>
      </div>

      <div className="pt-filters">
        <input
          placeholder="Поиск по имени, телефону, ИНН..."
          value={filter.search}
          onChange={e => setFilter(f => ({ ...f, search: e.target.value }))}
          style={{ flex:1, padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }}
        />
        <select value={filter.status} onChange={e => setFilter(f => ({ ...f, status: e.target.value }))}>
          <option value="all">Все сотрудники</option>
          <option value="active">Активные</option>
          <option value="fired">Уволенные</option>
        </select>
      </div>

      <table className="pt-table">
        <thead>
          <tr>
            <th>ФИО</th>
            <th>Телефон</th>
            <th>ИНН</th>
            <th>Должность</th>
            <th>Категория</th>
            <th>Объект</th>
            <th>Статус</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr><td colSpan={8} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Загрузка...</td></tr>
          )}
          {!loading && filtered.length === 0 && (
            <tr><td colSpan={8} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Нет сотрудников</td></tr>
          )}
          {filtered.map(e => (
            <tr key={e.id} style={{ opacity: e.is_active ? 1 : 0.6 }}>
              <td>
                <div style={{ fontWeight:600, color:'#111827' }}>{e.full_name}</div>
                {e.fired_at && (
                  <div style={{ fontSize:11, color:'#dc2626' }}>
                    Уволен: {new Date(e.fired_at).toLocaleDateString('ru')}
                  </div>
                )}
              </td>
              <td style={{ color:'#374151' }}>{e.phone || '—'}</td>
              <td style={{ color:'#6b7280', fontSize:13 }}>{e.inn || '—'}</td>
              <td style={{ color:'#374151' }}>{e.position || '—'}</td>
              <td>
                {e.category && (
                  <span className="badge" style={{
                    background: e.category === 'manager' ? '#d1fae5' : e.category === 'admin' ? '#dbeafe' : '#f3f4f6',
                    color: e.category === 'manager' ? '#065f46' : e.category === 'admin' ? '#1e40af' : '#374151'
                  }}>{e.category}</span>
                )}
              </td>
              <td style={{ color:'#6b7280', fontSize:13 }}>{e.hotel_name || '—'}</td>
              <td>
                <span className="badge" style={{
                  background: e.is_active ? '#d1fae5' : '#fee2e2',
                  color: e.is_active ? '#065f46' : '#dc2626'
                }}>
                  {e.is_active ? 'Активен' : 'Уволен'}
                </span>
              </td>
              <td>
                {e.is_active ? (
                  <button className="btn-icon danger" title="Уволить" onClick={() => fireEmployee(e.id)}>🔴</button>
                ) : (
                  <button className="btn-icon" title="Восстановить" onClick={() => restoreEmployee(e.id)}>✅</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
